import PropTypes from 'prop-types';

import Header from '../common/header-simple';

// ----------------------------------------------------------------------

export default function SimpleLayout ({ children, showAccount = false, title, backTo }) {
  return (
    <>
      <Header showAccount={showAccount} title={title} backTo={backTo} />

      {children}
    </>
  );
}

SimpleLayout.propTypes = {
  children: PropTypes.node,
  showAccount: PropTypes.bool,
  title: PropTypes.string,
  backTo: PropTypes.string,
};
